import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { CompaniesAppGzDataProvider } from '../dataProvider/CompaniesAppGzDataProvider';

export class CompaniesAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, CompaniesAppGzDataProvider);
  }
}
